const textArea = document.querySelectorAll('.textarea-with-counter');

textArea.forEach((textarea) => {
  const parentElement = textarea.closest('.mod-input');
  textarea.addEventListener('input', (input) => {
    const characterCountElement = parentElement.querySelector('.mod-input__curr-character');
    characterCountElement.textContent = `${input.target.value.length}`;
  });
});
